import { ColorOptions } from '@jfs/ui-new'
import { useEffect } from 'react'
import { TextInputLabelToolTip } from '../../../../../components/TextInputLabelToolTip'
import { useLazyApiData, useStores } from '../../../../../data/store'

interface PackageDescriptionProps {}

export const PackageDescription = (props: any) => {
  const { fetchMdrPackageDetails } = useStores((store) => ({
    fetchMdrPackageDetails: store.fetchMdrPackageDetails,
  }))
  console.log('props?.borderColor ', props)
  const [lazyFetchMdrPackageDetails, fetchMdrPackageHandler] = useLazyApiData(fetchMdrPackageDetails)

  useEffect(() => {
    if (props.allValues.feePackageId) {
      lazyFetchMdrPackageDetails(props.allValues.feePackageId)
    }
  }, [props?.allValues?.feePackageId])

  console.log('fetchMdrPackageHandler=', fetchMdrPackageHandler)
  const onInfoIconPress = () => {}

  return (
    <TextInputLabelToolTip
      label="Package Description"
      modalDetails={{
        data: fetchMdrPackageHandler?.data
          ? fetchMdrPackageHandler?.data?.feePkgName + '|' + (fetchMdrPackageHandler?.data?.schemeDetail ?? '')
          : '',
      }}
      value={props.allValues.feePackageId ? fetchMdrPackageHandler?.data?.feePkgName : 'NA'}
      numberOfLines={1}
      type="label"
      borderRadius={4}
      labelPaddingBottom={8}
      editable={false}
      focusBorderColor={'#D1D3E2' as ColorOptions}
      color={'BLACK_21'}
      fontSize={12}
      minHeight={30}
      paddingVertical={0}
      fontFamily="jiotype-medium"
      bgColor={props?.bgColor}
      disabled={props?.disabled}
      paddingHorizontal={props?.paddingHorizontal ?? 16}
      borderColor={props?.borderColor ?? ('#D1D3E2' as ColorOptions)}
    />
  )
}
